<template>
  <div>
    <subnavbar-inventario></subnavbar-inventario>
    <!-- keep-alive solo para la lista de productos: conserva filtros, pagina y scroll
         al ir a editar un producto y volver. El resto de las vistas no se cachean. -->
    <keep-alive :include="['ProductsList']">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>


<script>
import SubnavbarInventario from '../navbars/Subnavbar-inventario.vue'
export default {
  components: {
    SubnavbarInventario
  }
};
</script>